import React from 'react';

import { connect } from  'react-redux';

import { Redirect, Link } from 'react-router-dom';

import {api} from '../../actions/_request';

//libs
import Select , {Async}  from 'react-select';
import moment from 'moment';

// styling
import './style.css';

import {
    Card, CardBlock,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,
    Input,
    Badge,
    Row,
    CardTitle
} from 'reactstrap';

import {
    AreaChart, Area, BarChart, Bar,
    PieChart, Pie,
    XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell, Sector,
    ResponsiveContainer
} from 'recharts';

import _ from 'underscore';



//icons
import FAfloppyO from 'react-icons/lib/fa/floppy-o';
import FAchevronleft from 'react-icons/lib/fa/chevron-left';
import Fasearch from 'react-icons/lib/fa/search';
const {PropTypes} = React;

const CustomTooltip  = React.createClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },

  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label,fill } = this.props;
      // style={{width: '100%', height: '280px'}}
      console.log('propiedades grafica--->',this.props);
      return (
        <div className="custom-tooltip">
				{
				  payload.map((item, i) => 
				  <p className="label text-capitalize" style={{ 'color': ''+item.fill }} >{`${item.name} : $${new Intl.NumberFormat().format(item.value)}`}</p>
				  )
				}
                         
        </div>
      );
    }
    return null;
  }
});

const CustomTooltip2  = React.createClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },

  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label,fill } = this.props;
      // style={{width: '100%', height: '280px'}}
      console.log('propiedades grafica--->',this.props);
      return (
        <div className="custom-tooltip">
				{
				  payload.map((item, i) => 
				  <p className="label text-capitalize" style={{ 'color': ''+item.fill }} >{`${item.name} : ${item.value} %`}</p>
				  )
				}
                         
        </div>
      );
    }
    return null;
  }
});

class Reportes extends React.Component
{
	constructor(props){
		super(props)

		var fecha = new Date( moment().format('Y-MM-DD')+'T12:00:00Z');
				
		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
		

        var firstDay = new Date('Y-m-d',y, m, 1);
        var lastDay = new Date(y, m + 1, 0);
        var dia=lastDay.getDate();
        m++;
        if(m==13)m=1;	

		this.state = {
			reporte : {
				reporte_id : 1,
				// fecha_1 :moment(`${y}-${m}-1`).format('Y-MM-DD') ,
				// fecha_2 : moment(`${y}-${m}-${dia}`).format('Y-MM-DD') ,
				fecha_1 :'' ,
				fecha_2 : '' ,
				filtro_2 : '',
				user_id : '',
				tipo_id:0,
				mes:(fecha.getMonth()+1),
			    ano:2018,

			},
			data:[],
			tipo:1,
			usuarios : [],
			urlreporte:"",
			urlreporte2:"",
			routeEntrega : "",
			routesinpv:'',
			reporte_contpaq:'',
			inicio:0,


			cliente : null,
		}

		this.handleInputChange = this.handleInputChange.bind(this);
		this.search = this.search.bind(this);
		this.filter = this.filter.bind(this);
    
	}

	componentDidMount(){
        let self = this;

        api().get('/fecha_inicio_final')
        .then(function(response)
        {

        	self.props.cambio_fechas(response.data.inicio,response.data.final);

        	self.setState({
            reporte : {
            	reporte_id : 1,
				fecha_1 : response.data.inicio,
				fecha_2 : response.data.final ,
			},
        });
                api().get(`/reporte/produccionindividual_dashboard/1/${response.data.inicio}/${response.data.final}/0`)
		        .then(function(response)
		        {
		            self.setState({
		               data : response.data.datos,
                       tipo:response.data.tipo
		                
		            });
		            
		        });
         
           
        });

		
	}

	 componentWillReceiveProps(nextProps)
    {
        let {inicio, final} = nextProps;
      
        let self = this;

        this.setState({
            reporte : {
            	reporte_id : 1,
				fecha_1 :inicio ,
				fecha_2 : final ,
			},
        });
    }

	handleInputChange(event) {

		if(event === null) return;

		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		console.log(name)
		console.log(value)

		this.setState({
			reporte: {
				...this.state.reporte,
				[name]: value
			},

                urlreporte : "",
                urlreporte2 : "",
                routeEntrega : '',
                routesinpv:'',
                reporte_contpaq:'',
           
		});

		let reporte =this.state.reporte;
		if('fecha_1'==name){
			this.props.cambio_fechas(value,reporte.fecha_2);
		}else if('fecha_2'==name){
			this.props.cambio_fechas(reporte.fecha_1,value);
		}

	}

	handleSelectChange(select, name) {

		const value = select === null ? null : select.value;

		this.setState({
			reporte: {
				...this.state.reporte,
				[name]: value
			},
			urlreporte : "",
            urlreporte2 : "",
            routeEntrega : '',
            routesinpv:'',
            reporte_contpaq:'',
		});

		let reporte =this.state.reporte;
		if('fecha_1'==name){
			this.props.cambio_fechas(value,reporte.fecha_2);
		}else if('fecha_2'==name){
			this.props.cambio_fechas(reporte.fecha_1,value);
		}
	}



	search(){
		let {reporte } = this.state;

		let route ="/reporte"

		let self = this;
		switch(reporte.reporte_id){
			case 1: 
				route += "/produccionindividual_dashboard/1/" +reporte.fecha_1 + "/" + reporte.fecha_2+"/0";
				break;

		}
		
		if(route !== "/reporte" && reporte.reporte_id !== 7){
		api().get(route)
        .then(function(response)
        {
            self.setState({
                data : response.data.datos,
                tipo:response.data.tipo
            });
            console.log(response.data)
        });
    }


	}

	filter(evt){

		let {reporte} = this.state;
		let route ="/reporte"
		console.log(reporte.reporte_id);

		let self = this;
		switch(reporte.reporte_id){
			case 1: 

			if(evt.tipo == '1'){
					route += "/produccionindividual_dashboard/2/" +reporte.fecha_1 + "/" + reporte.fecha_2+"/"+evt.id;
				}else{
					// route += "/produccionindividual_dashboard/1/" +reporte.fecha_1 + "/" + reporte.fecha_2+"/0";
				}

				break;
			case 2: 
			if(evt.estado == 'departamento'){
					route += "/produccion/" + reporte.fecha_1 + "/" + reporte.fecha_2;
				}else{
					route += "/produccion_departamento/"+evt.id + '/' + reporte.fecha_1 + "/" + reporte.fecha_2;
				}

				break;
			case 3: 
				if(evt.estado == 'individual'){
					route += "/garantia/" + reporte.fecha_1 + "/" + reporte.fecha_2;
				}else{
					route += "/garantiadepartamento/"+evt.id + '/' + reporte.fecha_1 + "/" + reporte.fecha_2;
				}
				break;
			case 4: 


				break;
		}

		if(route !== "/reporte"){

		api().get(route)
        .then(function(response)
        {
            self.setState({
               data : response.data.datos,
                tipo:response.data.tipo
            });
            console.log(response.data)
        });
    	}

	}
	formateo(value) {
     var decimals =  2;
   var  separators =[',', ",", '.'];
    var number = (parseFloat(value) || 0).toFixed(decimals);
    if (number.length <= (4 + decimals))
        return '$' +number.replace('.', separators[separators.length - 1]);
    var parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];
    var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
    var start = value.length - 6;
    var idx = 0;
    while (start > -3) {
        result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
        idx = (++idx) % 2;
        start -= 3;
    }
    return '$' + result;
}


	render(){
		console.log('data-->',this.state);

		let {reporte,tipo} = this.state;
		let show = false;
		let etiqueta_filtro_2 = '';
		let opciones_filtro2 = '';
		let title = "";
		let key = '';
		let grafica = false;
		let PDF =false;
		let etiqueta="Fecha de Inicio:";
		if(reporte.reporte_id === 7){
			etiqueta = "Fecha:";
		}
		switch(reporte.reporte_id){
			case 1:
				show = true;
				title = "Produccion individual ";
				key ="tecnicos";
				if(tipo==2){
					key ="total";
				}
				grafica = true;
				break;
			case 2:
				title = "Utilidad por departamento";
				show = true;
				key ="total";
				grafica = true;
				break;
			case 3: 
				title = "Garantias";
				key="Garantias";
				grafica = true;
				break;
			case 4: 
				title = 'cumplimiento de citas';
				key = "Total";
				grafica = true;
				break;
				case 5: 
				PDF=true;
				
				grafica = false;
				break;

			default:
				show = false;
		}

		 
	     
	   

		return(
			<div className="view">
				<div className="view-header">
					<header className="title text-white">
						<h1 className="h4 text-uppercase">Reportes</h1>

						
					</header>
				</div>
				<div className="view-content view-components">
					<Card className="mb-4">
						<CardBlock>

							<div className="row mb-3">
								
								
							    
								
								<div className="col-sm-4 col-md-2 col-12">
									<div className="form-group">
										<label className>{etiqueta}</label>
										<input
											type="date" 
											className="form-control"
											name="fecha_1"
											value={reporte.fecha_1 || ''}
											onChange={this.handleInputChange}
										/>
									</div>
								</div>
							    
							   
								
									<div className="col-sm-4 col-md-2 col-12">
										<div className="form-group">
											<label className>Fecha Final:</label>
											<input
												type="date" 
												className="form-control"
												name="fecha_2"
												value={reporte.fecha_2 || ''}
												onChange={this.handleInputChange}
											/>
										</div>
									</div>
								
								 
								<div className="col-sm-4 col-md-2 col-12 text-right">
									<label><br/></label><br/>
									<Button color='success' onClick={this.search}> <Fasearch/> </Button>
								</div>
							</div>
							
						</CardBlock>
					</Card>
					<Card style={{'flex': '3 0 0'}}>
					
						
                    <CardBlock>
                        <CardTitle className="text-uppercase h6">{title}  <Button color="success" className="mx-4" onClick={this.search} >
                                Regresar
                            </Button></CardTitle>
                        <div className="small mb-4 card-subtitle"></div>
                        <div style={{width: '100%', height: '280px'}}>
                            <ResponsiveContainer>
                                <BarChart width={730} height={250} data={this.state.data}>
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="label" />
                                  <YAxis />
                                  
     								{
                                    (Object.keys(this.state.data).length === 0 ||tipo === 1)?<Tooltip/>:
                                    <Tooltip content={<CustomTooltip/>}/>


                                  }

                                  <Legend />
                                  <Bar dataKey={key} fill='#406CBF' onClick={this.filter} minPointSize={1} />
                                  {
                                  	tipo === 2 && 
                                  	<Bar dataKey="meta" fill='green' onClick={this.filter}  minPointSize={1} />
                                  }
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </CardBlock>

                    { tipo==2&&

                	<CardBlock>
                        <CardTitle className="text-uppercase h6"> Proyección al Día</CardTitle>
                        <div className="small mb-4 card-subtitle"></div>
                        <div style={{width: '100%', height: '280px'}}>
                            <ResponsiveContainer>
                                <BarChart width={730} height={250} data={this.state.data}>
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="label" />
                                  <YAxis />                                  
     							  {
                                    (Object.keys(this.state.data).length === 0)&& true?<Tooltip/>:
                                    <Tooltip content={<CustomTooltip2/>}/>


                                  }
                                  <Legend />                            
                                  <Bar dataKey="esperado" fill='green' onClick={this.filter} minPointSize={1} />
                                  <Bar dataKey="actual" fill='orange' onClick={this.filter} minPointSize={1} />
                                 </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </CardBlock>
                }
               
                 {
                	//(this.state.reporte.reporte_id == 1 && typeof this.state.data[0] !== 'undefined') &&
                	//<Lista_tickets  lista={this.state.data[0].tickets}  data={this.state.data[0]} />
                }
                
                

                </Card>
				</div>	
			</div>
			)
	}
}

export default Reportes;


// WEBPACK FOOTER //
// ./src/views/dashboard/reporte_individual.js